import React from 'react';
import { useIntl } from 'react-intl';

// type LocalizedTextProps = {
//   id?: string; // Translation key (optional)
//   defaultText?: string; // Fallback (e.g. API value or manual default)
//   children?: React.ReactNode; // Last-resort fallback
// };

const LocalizedText = ({ id, defaultText, children }) => {
  const intl = useIntl();

  if (id) {
    // Try to format
    const translated = intl.formatMessage({ id, defaultMessage: defaultText });

    // If translation not found, react-intl just returns the `id`
    if (translated === id) {
      return <>{defaultText ?? children ?? ''}</>;
    }
    return <>{translated}</>;
  }

  // If no ID → just show the fallback or children
  return <>{defaultText ?? children ?? ''}</>;
};

export default LocalizedText;
